import { useEffect, useState } from 'react';
import { DISPLAY_LANG } from '../../../config';
import { useNavigate } from 'react-router-dom';
import Loading from '../../../components/loading';
import api from '../../../axios';
import '../../../stylesheets/sslAgreementPage.css';

const agreementTitle = {
  en: 'SSL Certificate Agreement',
  am: 'SSL Հաստագիր Համաձայնություն',
  ru: 'Соглашение SSL Сертификата',
};

const agreementText = {
  en: 'Please read and accept the agreement to proceed with your SSL certificate issuance.',
  am: 'Խնդրում ենք կարդալ և ընդունել համաձայնությունը՝ շարունակելու համար ձեր SSL սերտիֆիկատի թողարկումը։',
  ru: 'Пожалуйста, прочитайте и примите соглашение, чтобы продолжить выпуск вашего SSL сертификата.',
};

const domainLabel = {
  en: 'Domain',
  am: 'Տիրույթ',
  ru: 'Домен',
};

const productCodeLabel = {
  en: 'Product Code',
  am: 'Ապրանքի Կոդ',
  ru: 'Код Продукта',
};

const agreementLabel = {
  en: 'Agreement',
  am: 'Համաձայնություն',
  ru: 'Соглашение',
};

export default function SSLAgreementPage() {
  const [domainName, setDomainName] = useState('');
  const [productCode, setProductCode] = useState('');
  const [agreement, setAgreement] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [agreed, setAgreed] = useState(false);
  const [authResponse, setAuthResponse] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const ssl_approved_domain_name = localStorage.getItem('ssl_approved_domain_name') || '';
    const ssl_product_code = localStorage.getItem('ssl_product_code') || '';
    setDomainName(ssl_approved_domain_name);
    setProductCode(ssl_product_code);

    if (!ssl_approved_domain_name || !ssl_product_code) return;

    setLoading(true);
    setError(null);

    window.scrollTo(0, 0);

    api.post('ssl/product-agreement', {
      product_code: ssl_product_code
    })
      .then(res => {
        setAgreement(res.data.Agreement || '');
        setAuthResponse(res.data.AuthResponse || {});
      })
      .catch(err => setError(err?.message || 'Request failed'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loading />;

  return (
    <div className="ssl-agreement-root">
      <h2 className="ssl-agreement-title">
        {agreementTitle['en']}
      </h2>

      <div className="agreement-panel">
        <div className="field">
          <label>{domainLabel['en']}</label>
          <div className="value">{domainName || '-'}</div>
        </div>
        <div className="field">
          <label>{productCodeLabel['en']}</label>
          <div className="value">{productCode || '-'}</div>
        </div>

        <div className="agreement-container">
          <label className="agreement-label">
            {agreementLabel['en']} / Sectigo
          </label>
          <div className="agreement-text">
            {agreement || agreementText['en']}
          </div>
        </div>

        <div className="checkbox-wrapper">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              className="checkbox-input"
            />
            <span className="checkbox-text">
              {
               DISPLAY_LANG === 'am' ? 
                'Ես ընդունում եմ վերը նշված պայմանները' : 
               DISPLAY_LANG === 'ru' ? 
                'Я принимаю условия, указанные выше' : 
                'I accept the above terms and conditions'
              }
            </span>
          </label>
        </div>

        <div className="actions">
          <button className="continue-btn" onClick={() => navigate('/user/ssl/order')} disabled={!agreed}>
            Continue
          </button>
        </div>

        {error && <div className="error">{error}</div>}
      </div>
    </div>
  );
}
